import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Router, NavigationEnd, ActivatedRoute, Event } from '@angular/router';
// import { Spinkit } from 'ng-http-loader';
import { filter, map } from 'rxjs/operators';
import { LocalStorageService } from './core/services/local-stroage.service'
import { Meta } from '@angular/platform-browser';
import { EventTrackingService } from './page-services/google/event-tracking.service';
import { PageTitleService } from './page-services/page-title.service';
import { HeaderComponent } from './views/header/header.component';
import { FooterComponent } from './views/footer/footer.component';
import { CommonModule, Location } from '@angular/common';
import { environment } from '../environments/environment';
import { ContinueWatchingService } from './core/services/continue-watching.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SnowplowService } from './core/analytics/snowplow.service';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet,HeaderComponent,FooterComponent,CommonModule, TranslateModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'nexgtv-node-website';
  
  // public spinkit = Spinkit;
  activeComponent: string = '';
  hideHeaderFooter: boolean = false;
  delayFooter: boolean = false;
  setDescription = '';
  setTitle = '';

  constructor(
    private router: Router,
    private googleEventTracking: EventTrackingService,
    private pageTitleService: PageTitleService,
    private activatedRoute: ActivatedRoute,
    public localStorageService: LocalStorageService,
    private meta: Meta,
    public location: Location,
    private continueWatchingService: ContinueWatchingService,
    private translate: TranslateService,
    public snowplowService: SnowplowService,
  ) {

    const userLanguage = localStorage.getItem('userLanguage') || "en";
    const allLanguages = JSON.parse(localStorage.getItem('allLanguages')!) || ['en', 'hi'];
    this.translate.addLangs(allLanguages);
    this.translate.setDefaultLang('en');
    this.translate.use(userLanguage);

    if (localStorage.getItem('debug') == 'false' && environment.production) {
      window.console.log = function () { };   // disable any console.log debugging statements in production mode
      window.console.error = function () { };
    } 
  }

  ngOnDestroy() {
    this.continueWatchingService.stopSync();
  }

  ngOnInit() {
    if (localStorage.getItem('isAuthenticated')) {
      this.continueWatchingService.startSync();
    }
     localStorage.setItem('reload','true');

    setTimeout(() => {
      localStorage.setItem('reload','false');
    }, 1000);
    const appTitle = this.pageTitleService.getTitle();
    this.setPageTitle();
    this.router
      .events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child:any = this.activatedRoute.firstChild;
          while (child.firstChild) {
            child = child.firstChild;
          }

          this.activeComponent = child.snapshot.data['componentName'];
        
          this.snowplowService.getCodeFromRoute(child)

          if (child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }

          return appTitle;
        })
      ).subscribe((ttl: string) => {
        // this.pageTitleService.setTitle(ttl);
        // this.setPageTitle();
      });



    this.router.events.subscribe((evt) => {

      if (evt instanceof NavigationEnd) {
        const urlPath = evt.urlAfterRedirects.split('?')[0];
        this.googleEventTracking.routeTrack(urlPath);
      }


      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
      this.setPageTitle();
    });

    if (localStorage.getItem('isAuthenticated') && !localStorage.getItem('profile_id') && !window.location.href.includes("/manage-profile")) {
      this.router.navigate(["manage-profile"], {
        relativeTo: this.activatedRoute,
        queryParamsHandling: 'preserve',
      });  
      // window.location.href = '/manage-profile';
      }

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        // RESET description first
        this.setDescription = '';
        this.setTitle = '';

        let currenturl = window.location.href;
        if (currenturl.includes("/manage-profile") || currenturl.includes("/search") || currenturl.includes("/app-pages")) {
          this.hideHeaderFooter = true;
          // let HeaderTag = document.getElementById('header');
          // HeaderTag.classList.add("no_click");

          // let footerTag = document.getElementById('footer');
          // footerTag.classList.add("no_click");
        } else {
          this.hideHeaderFooter = false;
          // let HeaderTag = document.getElementById('header');
          // HeaderTag.classList.remove("no_click");

          // let footerTag = document.getElementById('footer');
          // footerTag.classList.remove("no_click");
        }
      }
    });

    setTimeout(() => {
      this.delayFooter = true;
    }, 1000);

    
      setTimeout(() => {
        document.body.classList.remove('page-animation');
        document.getElementById("nexg_ngb-progressbar")!.style.display = 'none';
      }, 800);
  }

  getDescription(desc: any) {
  this.setDescription = desc;

  // Update meta description immediately
  this.meta.updateTag({
    name: 'description',
    content: this.setDescription || ''
  });
}


   getTitle(title:any) {
    this.setTitle = title;
  }

  setPageTitle() {
    if (this.router.url.includes('search')) {
      this.pageTitleService.setTitle(this.setTitle || `Explore Devotional Content on NexGTv - Spiritual Videos & More`);
      this.meta.updateTag({ name: 'description', content: `Watch a variety of devotional content including spiritual videos, prayers, bhajans, and more on NexGTv. Start your spiritual journey today`});
      this.meta.updateTag({ name: 'keywords', content: `Devotional Content, NexGTv, Spiritual Videos` });
      return;
    } else if (this.router.url.includes('viewall')) {
      this.pageTitleService.setTitle(this.setTitle || `Explore All News Channels on NexGTv - Watch Live TV`);
      this.meta.updateTag({ name: 'description', content: this.setTitle || `Browse all news channels on NexGTv. Stay updated with real-time news, live coverage, and breaking stories from India and around the world.`});
      this.meta.updateTag({ name: 'keywords', content: `News Channels,NexGTv, Live TV, Real-Time News, Breaking Stories, Live Coverage` });
    }

    const currentPage = this.router.url.split('/')[1];
    switch(currentPage) {
      case 'home':
        this.pageTitleService.setTitle(this.setTitle || `nexGTv - Live TV, Movies, and On-Demand Entertainment`);
        this.meta.updateTag({ name: 'description', content: this.setDescription || `Discover nexGTv, your go-to platform for live TV, movies, and on-demand shows. Stream 100+ channels, enjoy a variety of genres, and stay entertained anywhere.`});
        this.meta.updateTag({ name: 'keywords', content: `nexGTv, Live TV, On-Demand Entertainment` });
      break;

      case 'live-tv':
        this.pageTitleService.setTitle(this.setTitle || `nexGTv Live TV - Stream 100+ Channels Online`);
        this.meta.updateTag({ name: 'description', content: this.setDescription || `Watch live TV on nexGTv with over 100+ channels across genres like news, sports, entertainment, and more. Enjoy seamless streaming anytime, anywhere.`});
        this.meta.updateTag({ name: 'keywords', content: `nexGTv Live TV, Stream 100+ Channels, Online TV Streaming, News Channels` });
      break;

      case 'news-24x7':
        this.pageTitleService.setTitle(this.setTitle || `nexGTv News 24x7 - Live News Streaming Online`);
        this.meta.updateTag({ name: 'description', content: this.setDescription || `Stay updated with 24x7 live news on nexGTv. Stream breaking news, current affairs, and top stories from trusted channels anytime, anywhere on your device.`});
        this.meta.updateTag({ name: 'keywords', content: `nexGTv News 24x7, Live News Streaming, Breaking News, Current Affairs, Today Top Stories` });
      break;

      case 'devotional':
        this.pageTitleService.setTitle(this.setTitle || `nexGTv Devotional - Stream Spiritual Content Online`);
        this.meta.updateTag({ name: 'description', content: this.setDescription || `Experience peace with nexGTv Devotional. Stream live aartis, bhajans, and spiritual discourses to stay connected with your faith anytime, anywhere.`});
        this.meta.updateTag({ name: 'keywords', content: `nexGTv Devotional, Stream Spiritual Content, Live Aartis, Bhajans, Spiritual Discourses` });
      break;

      case 'subscribe':
        this.pageTitleService.setTitle(this.setTitle || `Subscribe for Devotional Content on NexGTv - Spiritual Videos`);
        this.meta.updateTag({ name: 'description', content: `Subscribe to NexGTv for exclusive devotional content, including spiritual videos, prayers, and bhajans. Join now for a fulfilling spiritual experience!`});
        this.meta.updateTag({ name: 'keywords', content: `Subscribe for Devotional Content, NexGTv, Spiritual Videos` });
      break;

      case 'aboutus':
        this.pageTitleService.setTitle(this.setTitle || `About Us - Learn More About NexGTv's Services`);
        this.meta.updateTag({ name: 'description', content: `Discover NexGTv's mission, vision, and the services we offer. Learn how we bring quality entertainment and spiritual content to our users.`});
        this.meta.updateTag({ name: 'keywords', content: `About Us, NexGTv` });
      break;

      case 'contactus':
        this.pageTitleService.setTitle(this.setTitle || `Contact Us - Get in Touch with NexGTv for Support & Inquiries`);
        this.meta.updateTag({ name: 'description', content:`Have questions or need support? Contact NexGTv today for assistance. We’re here to help with your queries and service requests.`});
        this.meta.updateTag({ name: 'keywords', content: `Contact Us, NexGTv, Support, Inquiries` });
      break;

      case 'faq':
        this.pageTitleService.setTitle(this.setTitle || `FAQ - Frequently Asked Questions About NexGTv Services`);
        this.meta.updateTag({ name: 'description', content: `Find answers to common questions about NexGTv's services, subscriptions, and features. Get all the information you need in our FAQ section.`});
        this.meta.updateTag({ name: 'keywords', content: `FAQ, Frequently Asked Questions, NexGTv, Services` });
      break;

      case 'terms':
        this.pageTitleService.setTitle(this.setTitle || `Terms and Conditions - NexGTv Service Agreement`);
        this.meta.updateTag({ name: 'description', content: `Review the terms and conditions for using NexGTv's services. Understand the rules and guidelines for a seamless and secure experience.`});
        this.meta.updateTag({ name: 'keywords', content: `Terms and Conditions, NexGTv, Service Agreement, Rules and Guidelines` });
      break;

      case 'policy':
        this.pageTitleService.setTitle(this.setTitle || `Privacy Policy - NexGTv Data Protection and Privacy Practices`);
        this.meta.updateTag({ name: 'description', content: this.setDescription || `Learn about NexGTv's privacy policy, data protection measures, and how we safeguard your personal information while using our services.`});
        this.meta.updateTag({ name: 'keywords', content: `Privacy Policy, NexGTv, Data Protection` });
      break;

      default:
        this.pageTitleService.setTitle(this.setTitle || `nexGTv - Live TV, Movies, and On-Demand Entertainment`);
        this.meta.updateTag({ name: 'description', content: this.setDescription || `Discover nexGTv, your go-to platform for live TV, movies, and on-demand shows. Stream 100+ channels, enjoy a variety of genres, and stay entertained anywhere.`});
        // this.setMetaDescription(this.setDescription);
        this.meta.updateTag({ name: 'keywords', content: `nexGTv, Live TV, On-Demand Entertainment` });
      break;
    }
  }
  
}

